import { useUserData } from './useUserData';
import {
  GetMe_me_organizations_myUserAssignment_settings,
  GetMe_me_organizations_settings,
  GetMe_me_organizations_workspaces_settings,
  GetMe_me_settings
} from '../models/legacy-graphql';
import { useSelectedOrganization } from './useSelectedOrganization';

export type ISelectedOrgSettings = Omit<GetMe_me_organizations_myUserAssignment_settings, '__typename'> &
  Omit<GetMe_me_organizations_settings, '__typename'>;

export type SettingsType = {
  userSettings: GetMe_me_settings | null;
  selectedOrgSettings: ISelectedOrgSettings | null;
  selectedWorkspaceSettings: GetMe_me_organizations_workspaces_settings | null;
};

export const useSettings = (): SettingsType => {
  const { userData } = useUserData();
  const { selectedOrganization, selectedWorkspace } = useSelectedOrganization();
  let userSettings: SettingsType['userSettings'] = null;
  let selectedOrgSettings: SettingsType['selectedOrgSettings'] = null;
  let selectedWorkspaceSettings: SettingsType['selectedWorkspaceSettings'] = null;

  if (userData) {
    userSettings = userData.settings;
  }
  if (selectedOrganization && selectedOrganization.myUserAssignment) {
    selectedOrgSettings = { ...selectedOrganization.settings, ...selectedOrganization.myUserAssignment.settings };
  }
  if (selectedWorkspace) {
    selectedWorkspaceSettings = selectedWorkspace.settings;
  }

  return {
    userSettings,
    selectedOrgSettings,
    selectedWorkspaceSettings
  };
};
